(function () {
    'use strict';

    run.admin.pages.rackootViewShared = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rackoot_data = document.getElementById('rackoot_data');
        if (rackoot_data.dataset.isPrivate == '1') {
            Swal.fire({
                title: translations.rackoots.visibility.privateWarning.title,
                html: translations.rackoots.visibility.privateWarning.html,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.confirmAlerts.close,
                confirmButtonText: translations.rackoots.share.enable,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('rackoot_uuid', rackoot_data.dataset.rackootUuid);
                    data.append('public', true);

                    axios.post(GlobalRoutes.rackoots.switch_public_status, data)
                }
            });
        }

        // If coming from the invite import
        if (document.body.classList.contains('user_logged_in') == true) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const from = urlParams.get('from');
            if (from !== null && from !== 'undefined') {
                if (from == 'add_public_tile') {
                    modal_invite_import()
                }
            }
        }

        function modal_invite_import()
        {
            const html = translations.inviteMessage.messages.fromAddPublicTile;
            Swal.fire({
                title: null,
                html: html,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
            });
        }
    }
})();
